import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { LoggingHandler } from '../errors/logging.service';
import { Router } from '@angular/router';
import { MatchError } from '../errors/error-matcher';
import { LocalStorageService } from '@app-services/local-storage.service';
import { STORAGE_NAMES } from '@app-shared/constants/constants';

const { SELECTED_ORGANISATION } = STORAGE_NAMES;

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  constructor(
    private cookieService: CookieService,
    protected loggingHandler: LoggingHandler,
    protected router: Router,
    protected matchError: MatchError,
    private localStorageService: LocalStorageService
  ) {}

  logout(changeUser?: boolean): void {
    this.localStorageService.removeData(SELECTED_ORGANISATION);
    document.location.href = `${environment.feUrl}signout${changeUser ? '?changeUser=true' : ''}`;
  }

  logIn(): void {
    document.location.href = environment.oidcSignInUri;
  }

  logInCredem(): void {
    document.location.href = environment.oidcCredemSignInUri;
  }

  getJwtTokenFromCookie(): boolean {
    const cookies = this.cookieService.get(environment.cookieAnchor);
    return cookies ? JSON.parse(cookies) : false;
  }

  isLoggedIn(): boolean {
    return this.getJwtTokenFromCookie();
  }
}
